import { Group, User } from '@/models';
import { AuthService, UserService, GroupService, ErrorService, NotificationService, LanguageService } from '@/services';
import { Component, OnInit } from '@angular/core';
import { FormControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SpinnerButtonConfig } from '@/ui/spinner-button/spinner-button-config';

@Component({
    selector: 'app-first-login-dialog',
    templateUrl: './first-login-dialog.component.html',
    styleUrls: ['./first-login-dialog.component.scss'],
    standalone: false
})
export class FirstLoginDialogComponent implements OnInit {
  btnConfig: SpinnerButtonConfig = {
    text: `Opslaan`,
  };

  user: User;
  groups: Group[];
  accountNumberText: string = `Studentnummer`;
  groupPinText: string = `Vul pincode in`;

  registerForm = new UntypedFormGroup({
    email: new UntypedFormControl(''),
    firstname: new UntypedFormControl('', [Validators.required]),
    lastname: new UntypedFormControl('', [Validators.required]),
    studentNumber: new UntypedFormControl(''),
    group: new UntypedFormControl('', [Validators.required]),
    groupPin: new FormControl<string>(''),
  });

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
    public dialogRef: MatDialogRef<FirstLoginDialogComponent>,
    private languageService: LanguageService,
    private groupService: GroupService,
    private errorService: ErrorService,
    private notificationService: NotificationService
  ) {
    this.btnConfig.text = this.languageService.translateWithCap('general.actions.save');
    this.accountNumberText = this.languageService.translateWithCap('account.number-student');
    this.groupPinText = this.languageService.translateWithCap('home.first-login-dialog.group-pin-text');
  }

  ngOnInit(): void {
    this.userService.getCurrentUser().subscribe({
      next: user => {
        this.user = user as User;
        this.registerForm.get('email')?.setValue(this.user.email);
        this.registerForm.get('email')?.disable();
        this.registerForm.get('firstname')?.setValue(this.user.firstname);
        this.registerForm.get('lastname')?.setValue(this.user.lastname);
      },
      error: err => this.errorService.onError(err),
    });
    this.groupService.getGroups(false).subscribe(
      groups => {
        this.groups = groups as Group[];
        this.groups.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
      },
      err => this.errorService.onError(err)
    );
  }

  save() {
    this.btnConfig.loading = true;
    if ((this.registerForm.get('group')?.value as Group).pin != this.registerForm.get('groupPin')?.value) {
      this.btnConfig.loading = false;
      this.notificationService.error(this.languageService.translateWithCap('home.first-login-dialog.incorrect-pin'));
      return;
    }
    this.user.firstname = this.registerForm.get('firstname')?.value;
    this.user.lastname = this.registerForm.get('lastname')?.value;
    this.user.firstLogin = false;
    this.user.studentnumber = this.registerForm.get('studentNumber')?.value;
    var promises: Promise<any>[] = [];
    promises.push(this.userService.updateUser(this.user).toPromise());
    var group = this.registerForm.get('group')?.value;
    if (group) {
      var groupObj = group as Group;
      promises.push(this.groupService.addStudentsToGroup(groupObj.id, [this.user.id]).toPromise());
    }
    Promise.all(promises)
      .then(() => {
        this.btnConfig.loading = false;
        this.dialogRef.close();
      })
      .catch(err => {
        this.btnConfig.loading = false;
        this.errorService.onError(err);
      });
  }

  onGroupChange(event: any) {
    if (event.value.pin) {
      this.registerForm.get('groupPin')!.addValidators([Validators.required]);
    } else {
      this.registerForm.get('groupPin')!.removeValidators([Validators.required]);
    }
    this.registerForm.get('groupPin')?.reset();
  }
}
